export default __webpack_public_path__ + "static/media/paypal.06287b3d.svg";